<template>
    <div class="mb-4 text-center">
        <div v-for="(item, i) in options" :key="i" :class="'form-check form-check-inline' + ((i+1 !== options.length) ? ' me-4' : '')">
            <input class="form-check-input" type="radio" :name="id" :id="id + i" :value="item.value" @change="setValue($event)" :checked="item.value === getValue()">
            <label class="form-check-label bold" :for="id + i">{{ item.title }}</label>
        </div>
        <div class="d-flex justify-content-center mt-2" v-if="error">
            <span class="color-red"><i class="fi fi fi-rr-exclamation me-2"></i> dit is een verplicht veld!</span>
        </div>
    </div>
</template>
<script>
export default {
    name:    'RadioField',
    props:   ['options', 'id', 'error'],
    methods: {
        setValue(event) {
            this.$store.commit('results/setQuestion', {
                id:    this.id,
                value: event.currentTarget.value
            });

            this.$parent.error = false;
        },
        getValue() {
            const question = this.$store.getters['results/getQuestionById'](this.id);

            if(question) {
                return question.value;
            }

            return null;
        }
    }
}
</script>
